import type { PaletteOptions } from '@mui/material/styles';
import { neutral } from './primitives.colors';
import { semanticDark } from './semantic.dark';
import { semanticLight } from './semantic.light';

export type AridePaletteMode = 'light' | 'dark';

export function buildPaletteOptions(mode: AridePaletteMode): PaletteOptions {
  const s = mode === 'dark' ? semanticDark : semanticLight;

  return {
    mode,
    primary: {
      light: s.primaryLight,
      main: s.primaryMain,
      dark: s.primaryDark,
      contrastText: s.primaryContrastText
    },
    secondary: {
      light: s.secondaryLight,
      main: s.secondaryMain,
      dark: s.secondaryDark,
      contrastText: s.secondaryContrastText
    },
    error: {
      light: s.errorLight,
      main: s.errorMain,
      dark: s.errorDark,
      contrastText: s.errorContrastText
    },
    warning: {
      light: s.warningLight,
      main: s.warningMain,
      dark: s.warningDark,
      contrastText: s.warningContrastText
    },
    info: {
      light: s.infoLight,
      main: s.infoMain,
      dark: s.infoDark,
      contrastText: s.infoContrastText
    },
    success: {
      light: s.successLight,
      main: s.successMain,
      dark: s.successDark,
      contrastText: s.successContrastText
    },
    text: {
      primary: s.textPrimary,
      secondary: s.textSecondary,
      disabled: s.textDisabled
    },
    divider: s.divider,
    background: {
      default: s.backgroundPrimary,
      paper: s.backgroundSecondary
    },
    grey: {
      50: neutral[0],
      100: neutral[100],
      200: neutral[200],
      300: neutral[300],
      400: neutral[400],
      500: neutral[500],
      600: neutral[600],
      700: neutral[700],
      800: neutral[800],
      900: neutral[900],
      A100: neutral[200],
      A200: neutral[300],
      A400: neutral[500],
      A700: neutral[700]
    }
  };
}
